import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import ApiService from "apiService";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useImportNodes = (id, onClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.IMPORT_NODE],
    (data) => ApiService.importNodes(data, id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_GROUP);
        toast.success('file imported successfully')
        onClose()
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useImportNodes